import React from 'react';
import ReactDOM from 'react-dom/client';
import RosannaPrescottArt from './RosannaPrescottArt';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RosannaPrescottArt />
  </React.StrictMode>
);
